/**
 * 全局统一的「客户端类型」判定
 *
 * 与 mobile/src/utils/client.ts 是同一套取值（后端 client / type 字段唯一约定）：
 *   wxxcx 微信小程序 | wxgzh 微信公众号 H5 | douyin 抖音小程序
 *   h5 移动端网页 | web PC 网页 | app 客户端（App / 桌面版）
 *
 * desk 只有两种产物，编译期就能定下来（__WEB__ 是构建注入的常量，另一端分支会被 DCE 掉）：
 *  - Web 端（浏览器打开 /web）  → 'web'
 *  - 桌面版（Electron 客户端）  → 'app'
 *
 * **任何地方需要 client / 判断当前是什么端，一律 import 这里的 clientType()，不要自己拼。**
 */
/** 客户端类型（后端 client 字段取值，前后端唯一约定） */
export type ClientType =
  | 'wxxcx' // 微信小程序
  | 'wxgzh' // 微信公众号 H5
  | 'douyin' // 抖音小程序
  | 'h5' // 移动端网页
  | 'web' // PC 网页（desk 的 Web 端）
  | 'app' // 客户端（desk 桌面版 / App）

/** 当前客户端类型（编译期常量） */
export const APP_CLIENT: ClientType = __WEB__ ? 'web' : 'app'

/** 当前客户端类型（全局唯一入口） */
export function clientType(): ClientType {
  return APP_CLIENT
}

/** 是否 Web 端（浏览器） */
export function isWebClient(): boolean {
  return APP_CLIENT === 'web'
}

/** 是否桌面版（Electron 客户端） */
export function isDesktopClient(): boolean {
  return APP_CLIENT === 'app'
}
